import React from 'react';

import styled from 'styled-components';

import { VOX_STATES } from '../../../consts/vox';
import RecentCalls from '../../CRM/Dialer/RecentCalls';
import OperatorsDropdown from '../../CRM/Dialer/OperatorsDropdown';
import { ValueOf } from '@utils/tsUtils';
import { OperatorsDropdownProps } from '@components/CRM/Dialer/OperatorsDropdown/OperatorsDropdown';
import DialerStatusSelector from '../../CRM/Dialer/DialerStatusSelector';

export interface DefaultStateProps {
  className?: string;
  state: ValueOf<typeof VOX_STATES>;
  isAuthorized?: boolean;
  calls: Array<{ name?: string; number: string }> | null;
  operators: OperatorsDropdownProps['operators'];
  manualState: ValueOf<typeof VOX_STATES>;
  isAlfaTravelManager: boolean;
  onCall: ({ value }: { value: string }) => void;
  onListen: ({ pbxId }: { pbxId: string }) => void;
  onOperatorsToggle: ({ isOpen }: { isOpen: boolean }) => void;
  onStatusChange: (data: {
    isManual: boolean;
    state: ValueOf<typeof VOX_STATES>;
    operatorState: ValueOf<typeof VOX_STATES>;
  }) => void;
  onRecentCallsToggle: ({ isOpen }: { isOpen: boolean }) => void;
}

class DefaultState extends React.Component<DefaultStateProps> {
  static defaultProps = {
    className: '',
    state: VOX_STATES.OFFLINE,
    onCall: Function.prototype,
    onListen: Function.prototype,
    onOperatorsToggle: Function.prototype,
    onRecentCallsToggle: Function.prototype,
    calls: null,
    operators: null,
    isAlfaTravelManager: true,
  };
  render() {
    const {
      calls,
      onCall,
      onListen,
      manualState,
      onOperatorsToggle,
      onRecentCallsToggle,
      onStatusChange,
      operators,
      state,
      isAuthorized,
      isAlfaTravelManager,
    } = this.props;
    return (
      <StyledDefaultState data-authorized={!!isAuthorized}>
        <StyledDialerContainer>
          <StyledCaller
            calls={calls}
            onCall={onCall}
            onToggle={onRecentCallsToggle}
            isAlfaTravelManager={isAlfaTravelManager}
          />
          <OperatorsDropdown
            state={state}
            onCall={onCall}
            onListen={onListen}
            onToggle={onOperatorsToggle}
            operators={operators}
            onTransfer={() => null}
            onRequestHelp={() => null}
          />
        </StyledDialerContainer>
        <DialerStatusSelector
          value={state}
          disabled={!isAuthorized}
          manualState={manualState}
          onChange={onStatusChange}
        />
      </StyledDefaultState>
    );
  }
}

const StyledFlex = styled.div`
  display: flex;
  align-items: center;
`;

const StyledCaller = styled(RecentCalls)`
  display: flex;
`;

const StyledDialerContainer = styled(StyledFlex)`
  flex: 1;

  > * + * {
    margin-left: 10px;
  }
`;

const StyledDefaultState = styled(StyledFlex)`
  height: 100%;
  width: 100%;

  &[data-authorized='false'] {
    ${StyledDialerContainer} {
      opacity: 0.5;
      pointer-events: none;
    }
  }
`;

export default DefaultState;
